import i18n from '@/translation/i18n';

const sheetTwo = [
    { header: i18n.t('sheet.sheet_two.title'), name: 'sheet-two' },
    { selector: 'instruction', name: i18n.t('sheet.sheet_two.instruction.title') },
    { selector: 'firstMeeting', name: i18n.t('sheet.sheet_two.first_meeting.title_short') },
    { selector: 'changeNames', name: i18n.t('sheet.sheet_two.change_names.title') },
    { selector: 'food', name: i18n.t('sheet.sheet_two.food.title') },
    { selector: 'cleaningProducts', name: i18n.t('sheet.sheet_two.cleaning_products.title') },
    { selector: 'clothing', name: i18n.t('sheet.sheet_two.clothing.title') },
    { selector: 'schoolSupplies', name: i18n.t('sheet.sheet_two.school_supplies.title') },
    { selector: 'apartmentEquipment', name: i18n.t('sheet.sheet_two.apartment_equipment.title') },
    {
        selector: 'householdAppliances',
        name: i18n.t('sheet.sheet_two.household_appliances.title_short')
    },
    { selector: 'otherMaterialNeeds', name: i18n.t('sheet.sheet_two.other_material_needs.title') },
    { selector: 'intangibleNeeds', name: i18n.t('sheet.sheet_two.intangible_needs.title') },
    { selector: 'specialGifts', name: i18n.t('sheet.sheet_two.special_gifts.title') },
    { selector: 'importantNeeds', name: i18n.t('sheet.sheet_two.important_needs.title') },
    { selector: 'volunteers', name: i18n.t('sheet.sheet_two.volunteers.title') },
    { selector: 'reflection', name: i18n.t('sheet.sheet_two.reflection.title') }
];

export default [sheetTwo];
